import firebase from 'firebase/app'
import 'firebase/messaging'
import { firebaseConfig, vapidKey } from '@src/services/.env.js'
import {
  isIOS,
  isSafari,
  isRunningAsPWA,
  getDeviceName,
  getDeviceId,
} from '@src/utils/platformUtil.js'
import { by } from '@services/custom.service'
import { PUSH_NOTIFICATION_TYPES } from '@src/constants/notification-constants.js'
import { TENNAT_API_URL, WEB_PUSH_VAPID_PUBLIC_KEY } from '@services/.env'
import { renderMarkdownToText, isMarkdown } from '@src/lib/markdown'
function logError(context, err) {
  console.error(`[PushNotifications] ${context}:`, err)
}

async function requestNotificationPermission() {
  try {
    const permission = await Notification.requestPermission()

    return permission === 'granted'
  } catch (err) {
    return false
  }
}

async function sendTokenHandler(token, type) {
  const body = {
    token,
    type,
    device_id: getDeviceId(),
    name: getDeviceName(),
  }
  try {
    await by(`${TENNAT_API_URL}push_token/refresh`, body)
  } catch (err) {
    logError('sendTokenHandler', err)
  }
}

async function initializeIOSPWAPush() {
  console.log('Detected iOS PWA, using Web Push API')
  try {
    const hasPermission = await requestNotificationPermission()
    if (!hasPermission) return

    const allRegistration = await navigator.serviceWorker.ready
    const existingSubscription = await allRegistration.pushManager.getSubscription()

    if (existingSubscription) await existingSubscription.unsubscribe()

    const registration = await navigator.serviceWorker.register('/service-worker.js')

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: WEB_PUSH_VAPID_PUBLIC_KEY,
    })
    console.log('iOS PWA Subscription:', subscription)
    await sendTokenHandler(JSON.stringify(subscription), PUSH_NOTIFICATION_TYPES.IOS_PWA_SAFARI)
    // Save subscription to backend
  } catch (err) {
    logError('Failed to register Web Push on iOS', err)
  }
}

async function initializeFCMPush() {
  console.log('Detected non-iOS PWA, using Firebase Cloud Messaging')
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }
  const messaging = firebase.messaging()
  try {
    const hasPermission = await requestNotificationPermission()
    if (!hasPermission) return

    const deviceToken = await messaging.getToken({
      vapidKey,
    })

    if (deviceToken) {
      console.log('Device Token', deviceToken)
      await sendTokenHandler(deviceToken, PUSH_NOTIFICATION_TYPES.FCM)
    } else console.log('No registration token available.')
  } catch (err) {
    logError('An error occurred while retrieving token', err)
  }
  messaging.onMessage((payload) => {
    console.log('[FCM Foreground] Received message:', payload)

    const data = payload.data || payload.notification || payload

    const notificationData = data.data || data
    const title = data.title || notificationData.title || 'No title'
    const body = data.body || notificationData.body || 'No body'
    const redirectPath = notificationData.redirect_path || '/'
    const notificationId = notificationData.id || null

    const notification = new Notification(isMarkdown(title) ? renderMarkdownToText(title) : title, {
      body: isMarkdown(body) ? renderMarkdownToText(body) : body,
      icon: require(`@src/assets/images/logo.svg`),
      badge: require(`@src/assets/images/logo.svg`),
      data: {
        url: redirectPath,
        id: notificationId,
        related_user_first_name: notificationData.related_user_first_name,
        related_user_last_name: notificationData.related_user_last_name,
        status: notificationData.status,
        inserted_at: notificationData.inserted_at,
      },
      requireInteraction: false,
      silent: false,
      tag: notificationId || 'default',
    })

    notification.onclick = (event) => {
      event.preventDefault() // prevent the browser from focusing the Notification's tab
      window.open(window.location.origin + redirectPath)
    }
  })
}

export default async function initializePushNotifications() {
  console.log('Entered firebaseInitialize')
  const isIOSPWA = isIOS() && isSafari() && isRunningAsPWA()
  if (isIOSPWA) {
    await initializeIOSPWAPush()
    return
  }
  await initializeFCMPush()
}
